// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Y8_Rna6ZQnj7N {
  display: block;
  position: relative;
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
._Y8_Rna6ZQnj7N span {
  display: block;
  position: absolute;
  left: 0;
  width: 24px;
  height: 3px;
  transform: rotate(0deg);
  transition: 0.3s ease;
  border-radius: 3px;
  opacity: 1;
  background-color: var(--ds-background-neutral-bold, #44546f);
}
@media (prefers-reduced-motion: reduce) {
  ._Y8_Rna6ZQnj7N span {
    transition: none;
  }
}
._Y8_Rna6ZQnj7N.zEvMTNRF1fdUHm span:nth-child(1) {
  top: 10.5px;
  left: 0px;
  transform: rotate(45deg);
}
._Y8_Rna6ZQnj7N.zEvMTNRF1fdUHm span:nth-child(2) {
  top: 10.5px;
  width: 0%;
  opacity: 0;
}
._Y8_Rna6ZQnj7N.zEvMTNRF1fdUHm span:nth-child(3) {
  top: 10.5px;
  left: 0px;
  transform: rotate(-45deg);
}
._Y8_Rna6ZQnj7N:not(.zEvMTNRF1fdUHm) span:nth-child(1) {
  top: 1.5px;
  transform-origin: left center;
}
._Y8_Rna6ZQnj7N:not(.zEvMTNRF1fdUHm) span:nth-child(2) {
  top: 10.5px;
  transform-origin: left center;
}
._Y8_Rna6ZQnj7N:not(.zEvMTNRF1fdUHm) span:nth-child(3) {
  top: 19.5px;
  transform-origin: left center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuIcon": `_Y8_Rna6ZQnj7N`,
	"isOpen": `zEvMTNRF1fdUHm`
};
export default ___CSS_LOADER_EXPORT___;
